import React from 'react';
import ReactDOM from 'react-dom';

/* Redux */
import {createStore, applyMiddleware} from 'redux';
import {Provider} from "react-redux";
import thunk from "redux-thunk";
import reducers from "./reducers/index.js";
import './assets/css/styles.css'

import App from './App.js';

let store = createStore(reducers, applyMiddleware(thunk))

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>
  , document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js